import { render, staticRenderFns } from "./ConteudoQuestao.vue?vue&type=template&id=50ebec34"
import script from "./ConteudoQuestao.vue?vue&type=script&lang=js"
export * from "./ConteudoQuestao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports